@if (config(); as templateData) {
  <!-- a11yRole assertion: the lib types it as non-optional but passes it through untouched, so undefined is safe -->
  <fa-icon
    [size]="templateData.size"
    [fixedWidth]="templateData.fixedWidth"
    [style.color]="templateData.color"
    [pull]="templateData.pull"
    [rotate]="templateData.rotate"
    [flip]="templateData.flip"
    [icon]="templateData.name | faIconName"
    [mask]="templateData.mask"
    [transform]="templateData.transform"
    [a11yRole]="templateData.a11yRole!"
    [title]="templateData.title"
  />
}
